import { ApiErrorHandler } from './api';
import * as Sentry from '@sentry/browser';

export class ApiSentryReporting implements ApiErrorHandler {
    onRequestError (request: Request, error: any): void {
        // TODO add context from request
        Sentry.captureException(error);
    }

    onResponseError (response: XMLHttpRequest, error: any): void {
        // TODO add context from response
        Sentry.captureException(error);
    }
}
